import React from 'react';
import { Crown, MapPin, Smartphone, Calendar, Check } from 'lucide-react';

export default function PremiumUpgrade({ onUpgrade }) {
  const features = [
    { icon: MapPin, text: 'Track up to 3 beach locations', free: '1 location', premium: '3 locations' },
    { icon: Smartphone, text: 'SMS text alerts', free: 'Email only', premium: 'Email + SMS' },
    { icon: Calendar, text: 'Extended forecast alerts', free: '1 day ahead', premium: '2-3 days ahead' },
  ];

  return (
    <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-2xl p-8 border-2 border-amber-200 shadow-xl">
      <div className="flex items-center gap-3 mb-4">
        <Crown className="w-8 h-8 text-amber-500" />
        <h3 className="text-2xl font-bold text-gray-800">Upgrade to Premium</h3>
      </div>

      <p className="text-gray-700 mb-6">
        Never miss a perfect beach day with premium features
      </p>

      <div className="space-y-4 mb-6">
        {features.map((feature, index) => (
          <div key={index} className="flex items-start gap-3 bg-white rounded-lg p-4">
            <feature.icon className="w-6 h-6 text-amber-500 flex-shrink-0 mt-1" />
            <div className="flex-1">
              <div className="font-semibold text-gray-800 mb-1">{feature.text}</div>
              <div className="flex items-center gap-4 text-sm">
                <span className="text-gray-500">Free: {feature.free}</span>
                <span className="text-amber-600 font-semibold">Premium: {feature.premium}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-lg p-6 mb-6">
        <div className="text-center mb-4">
          <div className="text-4xl font-bold text-gray-800">$2<span className="text-lg text-gray-500">/month</span></div>
          <div className="text-sm text-gray-500">or $19/year (save $5)</div>
        </div>
        <div className="flex items-center justify-center gap-2 text-sm text-gray-600">
          <Check className="w-4 h-4 text-green-500" />
          <span>7-day free trial, cancel anytime</span>
        </div>
      </div>

      <div className="space-y-3">
        <button
          onClick={() => onUpgrade('monthly')}
          className="w-full py-4 bg-gradient-to-r from-amber-500 to-yellow-500 text-white rounded-xl font-bold text-lg hover:from-amber-600 hover:to-yellow-600 transition-all shadow-lg hover:shadow-xl"
        >
          Start Free Trial - $2/month
        </button>

        <button
          onClick={() => onUpgrade('yearly')}
          className="w-full py-4 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-xl font-bold text-lg hover:from-green-600 hover:to-emerald-600 transition-all shadow-lg hover:shadow-xl"
        >
          Start Free Trial - $19/year
        </button>
      </div>

      <p className="text-xs text-center text-gray-500 mt-4">
        7-day free trial • No payment required during trial • Cancel anytime
      </p>
    </div>
  );
}
